import useTermsBuyNowPayLater from './useTermsBuyNowPayLater';

import TermButton from '../TermButton';

const TermsBuyNowPayLater: React.FunctionComponent = function () {
  const {
    showTerms,
    deferredGridClassName,
    deferredDurations,
    terms,
    termsGridClassName,
  } = useTermsBuyNowPayLater();
  if (!deferredDurations) return null;
  return (
    <>
      <h3 className="text-14-22-b mb-2">
        Select your interest free deferred term (months)
      </h3>
      <div className={deferredGridClassName}>
        {deferredDurations.map(({ term, label, key, id, onClick }) => (
          <TermButton
            term={term}
            label={label}
            id={id}
            key={key}
            onClick={onClick}
            deferred
          />
        ))}
      </div>
      {showTerms && terms && (
        <>
          <h3 className="text-14-22-b mb-2 mt-6">
            Select your repayment term (months)
          </h3>
          <div className={termsGridClassName}>
            {terms.map(({ term, label, key, id, onClick }) => (
              <TermButton
                term={term}
                label={label}
                id={id}
                key={key}
                onClick={onClick}
              />
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default TermsBuyNowPayLater;
